import {
  Chart,
  DoughnutController,
  ArcElement,
  Tooltip,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Plugin as ChartPlugin,
  PointElement,
  LineElement,
  Legend,
} from 'chart.js'
import { Doughnut, Pie, Bar, Line } from 'react-chartjs-2'
import type { Context as ChartLabelContext } from 'chartjs-plugin-datalabels/types/context'
import type { Options as ChartLabelOptions } from 'chartjs-plugin-datalabels/types/options'
import ChartDataLabels from 'chartjs-plugin-datalabels'

Chart.register(
  DoughnutController,
  ArcElement,
  Tooltip,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Legend
)
export const DoughnutChartElement = Doughnut
export const PieChartElement = Pie
export const BarChartElement = Bar
export const LineChartElement = Line
export const ChartDataLabelsPlugin = ChartDataLabels
export { Chart, ChartPlugin, ChartLabelContext, ChartLabelOptions }
